import { Loader } from '@/components/ui/loader';
import { BrandColors } from '@/constants/theme';
import { STRIPE_PUBLISHABLE_KEY } from '@/config/stripe';
import { stripeConnectService } from '@/lib/services/stripe-connect';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectPayouts,
} from '@stripe/react-connect-js';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

export const StripeConnectEmbed = () => {
  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async () => {
      const { client_secret } =
        await stripeConnectService.createAccountSession();
      return client_secret;
    };

    return loadConnectAndInitialize({
      publishableKey: STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret,
      appearance: {
        overlays: 'dialog',
        variables: {
          colorPrimary: BrandColors.primary,
        },
      },
    });
  });

  if (!STRIPE_PUBLISHABLE_KEY && !stripeConnectInstance) {
    return (
      <View style={styles.loading}>
        <Loader />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
        <ConnectPayouts />
      </ConnectComponentsProvider>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  loading: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },
});
